$ = require 'jquery'
Browser = require '@trello/browser'
ComposerLabelSelectorView = require 'views/card-composer/composer-label-selector-view'
ComposerMemberSelectorView = require 'views/card-composer/composer-member-selector-view'
ComposerPosSelectorView = require 'views/card-composer/composer-pos-selector-view'
ComposerSelectorMenuView = require 'views/card-composer/composer-selector-menu-view'
{ maybeDisplayLimitsErrorOnCardAdd } = require 'views/card/card-limits-error'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
htmlEncode = require 'lib/util/text/html-encode'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
makeErrorEnum = require 'lib/make-error-enum'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
Queue = require 'promise-queue'
SimplifiedStateManager = require 'lib/simplified-state-manager'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
t = require('views/internal/teacup-with-helpers')('list_add')
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'
memberTemplate = require 'views/templates/member'

CardComposerError = makeErrorEnum 'CardComposer', [
  'TooManyCards'
]

MAX_PARALLEL_CARD_CREATION = 5

module.exports = class CardComposerInlineView extends View

  className: 'card-composer'

  initialize: ->
    @makeDebouncedMethods 'render'

    @listenTo @model, 'change:idLabels change:idMembers',
      @renderSelectedItems
    @listenTo @model, 'change:vis',
      @autosaveCard
    @listenTo @model.labelList, 'add remove reset change',
      @frameDebounce @renderSelectedItems

    @listenTo SimplifiedStateManager,
      'full-view:unlocked': @renderDebounced

    @_cardCreationApiQueue = new Queue(MAX_PARALLEL_CARD_CREATION)

  events:
    'click .js-add-card': 'submitCard'
    'click .js-cancel': 'clearAndHide'
    'click .js-cc-menu': 'openMenu'

    'keyup': 'keyupEvent'
    'paste': 'pasteEvent'
    'keydown': 'keydownEvent'

  render: (args, callback) ->
    view = @

    data = _.extend { placeholder: @getPlaceholder(), hasTriggeredFullView: SimplifiedStateManager.isUnlocked('full-view') },
      @model.toJSON(board: true)

    # this toggles classes so lets do it before adding stuff to the DOM
    @renderVisibility()

    @$el.html(
      templates.fill(
        'card_composer_inline',
        data
      )
    )

    @renderSelectedItems()

    @defer =>
      # we could focus().select() here, but it might override what was typed
      # in the time between submitting the card and getting it
      # back from the server.
      Util.setCaretAtEnd(@$('.js-card-title')[0])

      # will select card with this callback if we just submitted a card
      callback?()

    @$('.js-card-title').autosize()

    @

  autosaveCard: ->
    val = $.trim(@$('.js-card-title').val())
    # Check placeholder value because of IE bug where it will save the placeholder
    if val != '' && val != @getPlaceholder()
      @submitCard(null, true)
    else
      @frameDebounce @renderVisibility()

  renderVisibility: ->
    @$el.toggleClass('hide', !@model.get('vis'))
    @

  clearTextField: ->
    @model.save('title', '')
    @$('.js-card-title').val('').trigger('autosize.resize')

  submitCard: (e, addedFromAutosave = false) ->
    if e then Util.stop(e)

    # Hide 'add label', 'select members', etc. popovers
    PopOver.hide()

    s = $.trim(@$('.js-card-title').val())

    if (s == "")
      @$el.find('.js-card-title').focus().select()
      return

    $manyCardsPopOverTarget = if e then $(e.target) else @$el
    options = {
      $elem: $manyCardsPopOverTarget,
      destinationBoard: @model.getBoard(),
      destinationList: @model.getList(),
    }
    if maybeDisplayLimitsErrorOnCardAdd(options)
      return

    cardTitles = _.compact(s.split(/\r\n|\r|\n/))
    count = cardTitles.length
    countString = count.toString()

    Promise.try =>
      if count > 100
        throw new CardComposerError.TooManyCards()

      if count > 1
        return new Promise (resolve) ->
          Confirm.toggle 'create many cards',
            elem: $manyCardsPopOverTarget
            html: l('confirm.create many cards.text', { count: countString })
            confirmText: l('confirm.create many cards.confirm', { count: countString })
            fxConfirm: (e) => resolve(true)
            fxCancel: (e) => resolve(false)
      else
        false
    .then (createOnePerLine) =>
      @clearTextField()
      openCard = e?.shiftKey == true

      if createOnePerLine
        @createMultipleCards(cardTitles, openCard)
      else
        # Dont select the card in autocreate card experiment so that a user
        # can use keyboard on board after creating card
        @createCard s, { openCard, selectCard: !addedFromAutosave, removeNewLines: true }

      @clearItems()
    .then =>
      if addedFromAutosave
        @hide()
        @renderVisibility()
    .catch CardComposerError.TooManyCards, =>
      # too many cards
      Confirm.toggle 'too many cards',
        elem: $manyCardsPopOverTarget
        html: l('confirm.too many cards.text', { count: countString })
        fxConfirm: (e) =>
          PopOver.hide()
    .done()

    return

  queueCreateCard: (title, params) ->
    @_cardCreationApiQueue.add =>
      @createCard(title, params)

  createCard: (title, { openCard, selectCard, removeNewLines } = {}) ->
    new Promise (resolve) =>
      title = title.trim()

      @$el.trigger 'prevent-scroll-selection'

      if removeNewLines
        title = title.replace(/(\r\n|\n|\r)/gm, ' ')

      # clone members and labels you added
      membersToAdd = _.clone(@model.get('idMembers'))
      idLabelsToAdd = _.pluck(@model.labelList.models, 'id')

      if title == ""
        resolve()
      else
        newCardData =
          name: title
          pos: @model.getList().calcPos(@model.get('index'))
          closed: false
          idLabels: idLabelsToAdd
          idMembers: membersToAdd
          dateLastActivity: Date.now()

        # advance to the next position
        @model.moveToNext()

        addsLabels = idLabelsToAdd.length > 0
        card = @model.getList().cardList.create(
          newCardData,
          {
            error: =>
              @model.getList().cardList.remove(card)
              resolve()
            success: (card) =>
              if addsLabels && membersToAdd.length > 0
                track("Card Composer", "Card Added", "With Members and Labels")
              else if membersToAdd.length > 0
                track("Card Composer", "Card Added", "With Members")
              else if addsLabels
                track("Card Composer", "Card Added", "With Labels")
              else
                track("Card Composer", "Card Added", "No items included")
              resolve()
              return
            @modelCache
          }
        )

        board = @model.getBoard()
        board.filter.addNewCard(card)

        if selectCard
          board.viewState.selectCard(card)

        if openCard
          Controller.showCardDetail(card, {
            runMethod: if card.shouldSuggestDescription() then 'expandDesc',
            method: 'via the Shift shortcut from card composer'
          })

  createMultipleCards: (cardTitles, openCard) ->
    numCardsLength = cardTitles.length

    for title, i in cardTitles
      if (cardTitles.length - 1  == i)
        @queueCreateCard(title, { openCard, selectCard: true })
      else
        @queueCreateCard(title)

    track("Card Composer", "Added Mulitple Cards", numCardsLength)

    return

  pasteEvent: ->
    @$('.js-card-title').focus().keyup().trigger('autosize.resize')
    return

  keydownEvent: (e) ->
    key = Keyboard.getKey(e)
    $titleInput = @$('.js-card-title')
    isTitle = $(e.target).closest('.js-card-title').hasClass('js-card-title')
    isJsAddCard = $(e.target).closest('.js-add-card').hasClass('js-add-card')

    if (isTitle || isJsAddCard) && !PopOver.isVisible && key == Keys.Enter
      Util.stop(e)
      @submitCard(e)
      return

    if key in [Keys.Tab, Keys.Enter]
      $titleInput.focus()
      word = Util.getWordFromCaret($titleInput[0])

      poEl = $(PopOver.view?.el)

      found = false

      if PopOver.view instanceof ComposerMemberSelectorView
        poEl.find('.js-members-list .item.selected:first .js-select-member').first().click()
        found = true

      else if PopOver.view instanceof ComposerLabelSelectorView
        poEl.find('.js-select-label.selected').first().click()
        found = true

      else if PopOver.view instanceof ComposerPosSelectorView
        if poEl.find('.js-pos-results').length > 0
          poEl.find('.js-pos-results li.selected:first a').first().click()
          found = true

      else if key == Keys.Tab && $titleInput.val() == ""
        Util.stop(e)
        @hide()
        if e.shiftKey
          $(@el).closest('.js-list').find('.editable:first .current').click()
        else
          $(@el).closest('.js-list').next().find('.editable:first .current').click()

      if found
        Util.stop(e)
        Util.insertSelection($titleInput, "", word.start, word.end)
        @model.set('title', $titleInput.val())

      @renderSelectedItems()
      PopOver.hide()
      return


  keyupEvent: (e) ->
    $titleInput = @$('.js-card-title')

    key = Keyboard.getKey(e)

    if key in [Keys.Tab, Keys.Enter]
      return

    if key == Keys.Escape
      Util.stop(e)
      PopOver.hide()
      $titleInput.focus()
      return

    # navigate menu list
    if Keyboard.isArrow(key)
      Util.stop(e)

      poEl = $(PopOver.view?.el)

      if PopOver.view instanceof ComposerMemberSelectorView
        Util.navMenuList(poEl.find('.js-members-list'), '.item', key)

      else if PopOver.view instanceof ComposerLabelSelectorView
        Util.navMenuList(poEl, '.js-select-label', key)

      else if PopOver.view instanceof ComposerPosSelectorView
        if poEl.find('.js-pos-results').length > 0
          Util.navMenuList(poEl.find('.js-pos-results'), 'li', key)

      return


    if !Browser.isTouch() && $(e.target).closest('.js-card-title').hasClass('js-card-title')

      word = Util.getWordFromCaret($titleInput[0])
      isMemberMatch = ///^@\S///.test(word.str.substring(0, 2))
      isLabelMatch = ///^\#\S///.test(word.str.substring(0, 2))
      isPosMatch = ///^\^\S///.test(word.str.substring(0, 2))
      term = word.str.substring(1).toLowerCase()

      # if match members, labels, or positions
      if isMemberMatch || isLabelMatch || isPosMatch

        if key in [Keys.Shift, Keys.Alt, Keys.Control]
          return

        else
          if isMemberMatch

            view = new ComposerMemberSelectorView({ @model, @modelCache })

            idBoardMems = _.pluck(@model.getBoard().memberList.filterDeactivated(force: true).models, 'id')
            idMems = Util.filterMembers(@modelCache, term, idBoardMems)

            if idMems.length > 0

              view.populate(idMems, true)

              PopOver.show
                elem: @$('.js-cc-menu')
                view: view

              $titleInput.focus()
              elem = $(view.el).find('.js-members-list .item:first')
              Util.selectMenuItem($(view.el).find('.js-members-list'), '.item', elem)
            else
              PopOver.hide()

          else if isLabelMatch
            view = new ComposerLabelSelectorView({ @model, @modelCache })
            labelNames = @model.getBoard().filterLabels(term)

            if labelNames.length > 0

              view.populate labelNames

              PopOver.show
                elem: @$('.js-cc-menu')
                view: view

              $titleInput.focus()
              elem = $(view.el).find('.edit-labels-pop-over .js-select-label:first')
              Util.selectMenuItem($(view.el).find('.edit-labels-pop-over'), 'li', elem)
            else
              PopOver.hide()

          else if isPosMatch
            view = new ComposerPosSelectorView({ @model, @modelCache })
            posNames = view.filterPos(term)

            if posNames.hasData

              view.populateResults posNames

              PopOver.show
                elem: @$('.js-cc-menu')
                view: view

              $titleInput.focus()
              elem = $(view.el).find('.js-pos-results li:first')
              Util.selectMenuItem($(view.el).find('.js-pos-results'), 'li', elem)
            else
              PopOver.hide()

      else

        # add current text
        @model.set('title', @$('.js-card-title').val())

        PopOver.hide()


  renderSelectedItems: ->

    # members
    idMembers = @model.get('idMembers')
    hasMembers = !_.isEmpty(idMembers)
    $members = @$('.js-list-card-composer-members').empty()
    for mem in @modelCache.get('Member', idMembers)
      $members.append("<div class='member js-remove-member' idMember='#{mem}'>#{ memberTemplate(mem.toJSON()) }</div>")

    # labels
    labels = @model.get('labels')
    hasLabels = !_.isEmpty(labels)
    $labels = @$('.js-list-card-composer-labels').empty()

    for label in @model.labelList.models when !_.isEmpty(label.get('color'))
      $labels.append("<div
          class='card-label card-label-#{label.get('color')} mod-card-front'
          title='#{htmlEncode(label.get('name'))}'
          >#{htmlEncode(label.get('name'))}</div>")

    @$('.js-clear-all-items').toggle(hasLabels || hasMembers)

    return


  openMenu: (e) ->
    Util.stop(e)
    track('Card Composer', 'Open Selector Menu')
    PopOver.toggle
      elem: e.target
      view: new ComposerSelectorMenuView({ @model, @modelCache })

  clearItems: (e) ->
    @model.clearItems()

  hide: (e) ->
    @model.save("vis", false)
    return

  clearAndHide: (e) ->
    # Set title to nothing so that autosave doesn't save on close
    @$('.js-card-title').val('')
    @clearItems()
    @hide()

  scrollIntoView: ->
    top = @$el.offset().top

    scrollable = @$el.closest('.list-cards')
    scrollable.scrollTop(top + @$el.height())

  getPlaceholder: ->
    l ['templates', 'card_composer_inline', 'enter-a-title-for-this-card-ellipsis']



// WEBPACK FOOTER //
// ./app/scripts/views/card-composer/card-composer-inline-view.coffee